import { FaWhatsapp } from "react-icons/fa";
import { useEffect } from "react";
import { useLocation } from "react-router";

const RefundAndCancalation = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return (
        <>
            <div>
                {/* navbar      */}
                <div className="bg-gray-50 p-5 shadow-lg flex justify-between items-center">
                    <div>
                        <h1 className="text-4xl font-bold">MyReading</h1>
                    </div>
                    <div className="flex items-center space-x-2">

                        <p className="text-lg font-bold">+91 9309140606</p>
                        <a
                            href="https://wa.me/919309140606"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp className="cursor-pointer hover:scale-110 text-green-500" size={24} />
                        </a>
                    </div>
                </div>
                {/* all textual content  */}
                <div className="flex flex-col justify-center p-5 max-w-5xl mx-auto">
                    <h1 className="text-2xl text-gray-800 font-bold mb-2">Refund, Return & Cancellation Policy</h1>
                    <p className="mb-3">Welcome to MyReading, our Library Management Software. By using our service, you agree to the following terms:</p>
                    <div className="p-4">
                        <ul className="list-disc space-y-4 p-3">
                            <li>
                                <span className="font-bold">1. Subscription Nature</span>
                                <ul className="list-disc pl-5 mt-2">
                                    <li>All purchases made on MyReading are for digital services.</li>
                                    <li>A subscription gives the user access to our library management features for the duration of the selected plan from the date of activation.</li>
                                    <li>After the subscription period ends, access automatically expires.</li>
                                    <li>Users may choose to renew or purchase a new subscription.</li>
                                </ul>
                            </li>
                            <li>
                                <span className="font-bold">2. Refund Policy</span>
                                <p className="mt-2">Because our product is a digital service and access is granted immediately upon activation, we do not offer refunds under these conditions:</p>
                                <ul className="list-disc pl-5 mt-2">
                                    <li>No refund after the subscription has been activated.</li>
                                    <li>No refund if any part of the digital content has been accessed or used.</li>
                                    <li>No refund for partial usage or unused time within the selected subscription period.</li>
                                    <li>No refund if the user does not use the service after purchase.</li>
                                </ul>
                                <p className="mt-2">Refunds may be considered only in these rare cases:</p>
                                <ul className="list-disc pl-5 mt-2">
                                    <li>Duplicate payment made by mistake.</li>
                                    <li>Payment deducted but subscription not activated.</li>
                                </ul>
                                <p className="mt-2">Such refunds will be processed only after verification and approval by our support team.</p>
                            </li>
                            <li>
                                <span className="font-bold">3. Cancellation Policy</span>
                                <ul className="list-disc pl-5 mt-2">
                                    <li>Once a subscription is activated, it cannot be cancelled.</li>
                                    <li>No early cancellation or partial refund is available for the active subscription.</li>
                                    <li>Users can simply choose not to renew after the subscription ends.</li>
                                </ul>
                            </li>
                            <li>
                                <span className="font-bold">4. Subscription Expiry</span>
                                <ul className="list-disc pl-5 mt-2">
                                    <li>Every subscription is valid for the duration specified in the purchased plan.</li>
                                    <li>After expiration, access stops automatically.</li>
                                    <li>There is no auto-renewal; renewal is optional and user-controlled.</li>
                                </ul>
                            </li>
                            <li>
                                <span className="font-bold">5. Contact Us</span>
                                <p className="mt-2">If you face any technical or payment-related issues, please contact our support team:</p>
                                <div className="mt-2">
                                    <p><span className="font-bold">Email:</span> <a href="mailto:info@shivaytech.com" className="text-blue-600">info@shivaytech.com</a></p>
                                    <p><span className="font-bold">Phone:</span> 9309140606</p>
                                    <p><span className="font-bold">Support Hours:</span> 7Hr</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RefundAndCancalation;
